import { FC, ChangeEvent, useRef, forwardRef, useImperativeHandle } from "react";
import { Falsy, ErrorInfo } from "../../types";
import { _ } from "../../utils/helpers";

interface TextareaProps {
    id: string
    value: string
    placeholder: string
    maxLength?: number
    getError?: (value: string) => Falsy | ErrorInfo
    onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void
}

export const Textarea:FC<TextareaProps> = forwardRef(({
    id,
    value,
    placeholder,
    maxLength,
    onChange,
    getError,
}, ref) => {


    const inputRef = useRef<HTMLTextAreaElement | null>(null)
    const errorRef = useRef<HTMLSpanElement | null>(null)
    const hasError = useRef<Falsy | ErrorInfo>(false)

    const showError = () => {
        if (!hasError.current) return
        errorRef.current!.innerHTML = _(hasError.current.message)
        errorRef.current!.classList.add('visible')
        inputRef.current!.classList.add('error')
    }
    const hideError = () => {
        errorRef.current!.classList.remove('visible')
        inputRef.current!.classList.remove('error')
    }

    useImperativeHandle(ref, () => ({
        showError,
        hideError
    }))

    return (
        <div className="w-100 df fd-c aifs input-container">
            <div className="input-slots w-100 df aifs">
                <textarea 
                    ref={inputRef}
                    id={id}
                    className="input textarea w-100"
                    placeholder={placeholder}
                    maxLength={maxLength}
                    value={value}
                    onChange={(e) => {
                        if (!getError) return onChange(e)

                        hasError.current = getError(e.currentTarget.value)

                        if (!hasError.current) hideError()

                        onChange(e)
                    }}
                    onBlur={() => {
                        if (hasError.current) showError()
                    }}
                />
            </div>
            <span 
                ref={errorRef}
                id={`${id}-error`} 
                className="input-error text s18-400 w-100"
            >
            </span>
        </div>
    )
})